$(function() {
    let found = window.location.pathname.match(/^\/(tasks|mam)\/.+/)

    if(found) {
        let url = `/${found[1]}/`
        window.history.replaceState("", "", url);
    }
});